import { RulebookErrorType } from "@next-platform/packages-ts-types";
import { compareErrorCode } from "../../../utils/compareErrorCode";
import RulebookAttachFailure from "./RulebookAttachFailure";
const readErrorCode = (error) => error?.response?.data?.errorCode;
/** Maps an attach request error to the failure the host app reports. */
const resolveRulebookAttachFailure = (error) => {
    const code = readErrorCode(error);
    if (compareErrorCode(code, RulebookErrorType.NOT_PUBLIC_FOR_PUBLIC_CHARACTER)) {
        return RulebookAttachFailure.NotPublicForPublicCharacter;
    }
    if (compareErrorCode(code, RulebookErrorType.PUBLIC_NOT_AVAILABLE) || compareErrorCode(code, RulebookErrorType.NOT_FOUND)) {
        return RulebookAttachFailure.Unavailable;
    }
    return RulebookAttachFailure.Failed;
};
export default resolveRulebookAttachFailure;
